import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-responsive-md border border-gray" }
const _hoisted_2 = { class: "bg-table-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, "First Name", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, "Last Name", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, "Role", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Relationship", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Primary Phone", -1 /* HOISTED */)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Emergency Contact")
const _hoisted_11 = {
  key: 0,
  class: "text-center"
}
const _hoisted_12 = {
  key: 1,
  class: "text-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Bereavement Contact", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions", -1 /* HOISTED */)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "table-loading" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_20 = ["colspan"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "No Contacts Found.", -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 2,
  class: "table-error"
}
const _hoisted_24 = { "colspan.bind": "columns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_PatientAuthorizedContactsRow = _resolveComponent("PatientAuthorizedContactsRow")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("th", _hoisted_8, [
          (_ctx.isPalliative)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Primary"))
            : _createCommentVNode("v-if", true),
          _hoisted_10
        ]),
        (_ctx.isPalliative)
          ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Other Emergency Contact"))
          : _createCommentVNode("v-if", true),
        (!_ctx.isPalliative)
          ? (_openBlock(), _createElementBlock("th", _hoisted_12, "CAHPS Survey"))
          : _createCommentVNode("v-if", true),
        _hoisted_13,
        _hoisted_14
      ])
    ]),
    (_ctx.isLoading || _ctx.isError || !_ctx.hasData)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
          _createCommentVNode(" LOADING "),
          (_ctx.isLoading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                return (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                    return (_openBlock(), _createElementBlock("td", null, _hoisted_18))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" EMPTY "),
          (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_22, 8 /* PROPS */, _hoisted_20)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" ERROR "),
          (!_ctx.isLoading && _ctx.isError)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                _createElementVNode("td", _hoisted_24, [
                  _createVNode(_component_ErrorMessageHandler, {
                    title: "Contact list",
                    "try-again": _ctx.getContacts
                  }, null, 8 /* PROPS */, ["try-again"])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.contacts, (contact) => {
          return (_openBlock(), _createBlock(_component_PatientAuthorizedContactsRow, {
            contact: contact,
            "is-re-order-requested": _ctx.isReOrderRequested,
            "patient-primary-address": _ctx.patientPrimaryAddress,
            columns: _ctx.columns,
            "is-palliative": _ctx.isPalliative,
            "patient-id": _ctx.patientId,
            "total-contacts": _ctx.totalContacts,
            "cahps-survey-recipient-index": _ctx.cahpsSurveyRecipientIndex,
            "relationships-enum": _ctx.relationshipsEnum,
            "contact-roles-enum": _ctx.contactRolesEnum,
            "cahps-survey-contact-enum": _ctx.cahpsSurveyContactEnum,
            "refresh-list": _ctx.getContacts,
            "move-up": _ctx.moveUp,
            "move-down": _ctx.moveDown,
            "update-contact": _ctx.updateAuthorizedContact,
            "delete-authorized-contact": _ctx.deleteAuthorizedContact
          }, null, 8 /* PROPS */, ["contact", "is-re-order-requested", "patient-primary-address", "columns", "is-palliative", "patient-id", "total-contacts", "cahps-survey-recipient-index", "relationships-enum", "contact-roles-enum", "cahps-survey-contact-enum", "refresh-list", "move-up", "move-down", "update-contact", "delete-authorized-contact"]))
        }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}